import { Box, Card, Grid, Stack, Typography } from '@mui/material'
import StatusText from 'common/component/StatusText'
import React, { useEffect, useMemo, useState } from 'react'
import defaultProductImage from '../../../assets/images/placeholderproduct.svg';
import colors from 'assets/theme/base/colors';
import { getStaticLegal } from '../../../redux/slices/common';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import Loader from 'common/Loader';
import NoDataFound from 'common/component/NoDataFound';

const SameDayDeliveryPageDetail = ({ legalId, fullRoleTabSlug }) => {
  const { grey } = colors;
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams();
  const fullRoleTab = useMemo(() => searchParams.get('roleTab'), [searchParams]);
  const { singleLegal, isLoading } = useSelector((state => state.common));
  const [nodataFound, setNodataFound] = useState(false)
  const fullRoleTabheading = useMemo(() => searchParams.get('heading'), [searchParams]);

  useEffect(() => {
    if (fullRoleTabheading) {
      dispatch(getStaticLegal({ id: fullRoleTabheading, platform: fullRoleTab })).unwrap().then(() => {
        setNodataFound(false)
      }).catch(() => {
        setNodataFound(true)
      });
    }
  }, [fullRoleTabheading, fullRoleTab])

  const sectionCard = (items) => (
    <Stack spacing={3}>
      {items?.map((item, idx) => (
        <Stack key={item._id || idx} direction="column" spacing={1} alignItems="start">
          <Box display="flex" flexDirection="row" gap={2}>
            {item.image?.url && (
              <Box
                component="img"
                src={item.image.url}
                alt={item.image?.alt || item.title}
                sx={{ width: 24, height: 24, objectFit: 'contain', flexShrink: 0 }}
              />
            )}
            <Typography variant='h6' fontWeight="600">{item.title || "-"}</Typography>
          </Box>
          <Box
            variant="body2"
            color={grey[600]}
            dangerouslySetInnerHTML={{ __html: item.description || "" }}
          />
        </Stack>
      ))}
    </Stack>
  )

  return (
    <>
      {isLoading ? <Loader /> : <>
        {nodataFound ? <NoDataFound /> :
          <Box p={4} pt={2} className="static-pages-container">

            {/**************** Page Title ****************/}
            <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3}>
                <Typography variant='h4' fontWeight="semibold" style={{ color: "#2E2E3A" }}>{fullRoleTabheading}</Typography>
                <StatusText status={singleLegal?.status ? "active" : "inactive"} />
              </Stack>
            </Card>

            {/***************** Visible On ****************/}
            <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={2} mt={2}>
                <Typography variant='h5' fontWeight="semibold">Visible On</Typography>
              </Stack>
              <Grid container alignItems="center" spacing={{ xs: 3, md: 4 }} mb={2}>
                <Grid item xs={12}>
                  <Stack direction="row" alignItems="center" spacing={3}>
                    {singleLegal?.displaySettings?.footer && (
                      <badge className="d-flex align-item-center jc-center" style={{ backgroundColor: "rgba(161, 98, 247, 0.20)", color: "#2E2E3A", padding: "7px 16px", borderRadius: "100px", minWidth: "80px", textAlign: "center", fontSize: "16px", lineHeight: "normal", fontWeight: "500" }}>Footer</badge>
                    )}
                    {singleLegal?.displaySettings?.hamburgerMenu && (
                      <badge className="d-flex align-item-center jc-center" style={{ backgroundColor: "rgba(161, 98, 247, 0.20)", color: "#2E2E3A", padding: "7px 16px", borderRadius: "100px", minWidth: "80px", textAlign: "center", fontSize: "16px", lineHeight: "normal", fontWeight: "500" }}>Hamburger Menu</badge>
                    )}
                  </Stack>
                </Grid>
              </Grid>
            </Card>

            {/***************** Meta Properties ****************/}
            <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                <Typography variant='h5' fontWeight="semibold">Meta Properties</Typography>
              </Stack>
              <Grid container alignItems="center" spacing={3} mb={2}>
                <Grid item xs={12}>
                  <Typography variant='body2' color={grey[600]} mb={1}>Meta Title</Typography>
                  <Typography variant='h5' fontWeight="medium">{singleLegal?.metaProperties?.title || "-"}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant='body2' color={grey[600]} mb={1}>Description</Typography>
                  <Typography variant='h5' fontWeight="medium">{singleLegal?.metaProperties?.description || "-"}</Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant='body2' color={grey[600]} mb={1}>Updated By</Typography>
                  <Typography variant='h5' fontWeight="medium">{singleLegal?.createdBy || "-"}</Typography>
                </Grid>
              </Grid>
            </Card>

            {/***************** Header Section ****************/}
            <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                <Typography variant='h5' fontWeight="semibold">Header Section</Typography>
                <StatusText status={singleLegal?.headerSection?.status ? "active" : "inactive"} />
              </Stack>
              {singleLegal?.headerSection?.status &&
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Typography variant='body2' color={grey[600]} mb={1}>Title (H1)</Typography>
                        <Typography variant='h5' fontWeight="medium">{singleLegal?.headerSection?.pageTitle || "-"}</Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant='body2' color={grey[600]} mb={1}>Description</Typography>
                        <Typography
                          variant="h5"
                          fontWeight="medium"
                          dangerouslySetInnerHTML={{ __html: singleLegal?.headerSection?.section?.description || "-" }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant='body2' color={grey[600]} mb={1}>Top Banner</Typography>
                        <img
                          style={{ borderRadius: '20px', width: '100%', height: '320px', objectFit: 'cover' }}
                          src={singleLegal?.headerSection?.section?.image?.url || defaultProductImage}
                          alt="No Image Found"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Grid container spacing={3}>
                      {singleLegal?.headerSection?.cta?.length > 0 && (
                        <Grid item xs={12}>
                          <Typography variant='body2' color={grey[600]} mb={1}>CTA Buttons</Typography>
                          <Stack direction="row" flexWrap="wrap" gap={2}>
                            {singleLegal?.headerSection?.cta?.map((cta, idx) => (
                              <Box key={idx} sx={{ border: '1px solid #ededed', borderRadius: 1.5, p: 1.5 }}>
                                <Typography variant='body2' fontWeight="600">{cta?.name || "-"}</Typography>
                                <Typography variant='caption' color={grey[600]}>{cta?.link || "-"}</Typography>
                              </Box>
                            ))}
                          </Stack>
                        </Grid>
                      )}
                      {singleLegal?.headerSection?.points?.length > 0 && (
                        <Grid item xs={12}>
                          <Typography variant='body2' color={grey[600]} mb={1}>Feature Points</Typography>
                          <Stack spacing={1}>
                            {singleLegal?.headerSection?.points?.map((point, idx) => (
                              <Box key={idx} display="flex" gap={1}>
                                <Typography variant='body2' fontWeight="600">{point?.name || "-"}</Typography>
                                <Typography variant='body2' color={grey[600]}>{point?.desc || ""}</Typography>
                              </Box>
                            ))}
                          </Stack>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              }
            </Card>

            {/***************** Cannabis Delivery Today, Without the Dispensary Trip ****************/}
            {singleLegal?.dispensaryTrip?.status &&
              <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                  <Typography variant='h5' fontWeight="semibold">Cannabis Delivery Today, Without the Dispensary Trip</Typography>
                  <StatusText status={singleLegal?.dispensaryTrip?.status ? "active" : "inactive"} />
                </Stack>
                <Grid container spacing={3} mb={3}>
                  <Grid item xs={12} md={6}>
                    <Typography variant='body2' color={grey[600]} mb={1}>Section Title (H2)</Typography>
                    <Typography variant='h5' fontWeight="medium">{singleLegal?.dispensaryTrip?.pageTitle || "-"}</Typography>
                  </Grid>
                  {singleLegal?.dispensaryTrip?.description && (
                    <Grid item xs={12}>
                      <Typography variant='body2' color={grey[600]} mb={1}>Description</Typography>
                      <Typography variant='h5' fontWeight="medium">{singleLegal?.dispensaryTrip?.description}</Typography>
                    </Grid>
                  )}
                </Grid>
                {sectionCard(singleLegal?.dispensaryTrip?.section)}
              </Card>
            }

            {/***************** How Same-Day Weed Delivery Works ****************/}
            {singleLegal?.weedDeliveryWorks?.status &&
              <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                  <Typography variant='h5' fontWeight="semibold">How Same-Day Weed Delivery Works</Typography>
                  <StatusText status={singleLegal?.weedDeliveryWorks?.status ? "active" : "inactive"} />
                </Stack>
                <Grid container spacing={3} mb={3}>
                  <Grid item xs={12} md={6}>
                    <Typography variant='body2' color={grey[600]} mb={1}>Section Title (H2)</Typography>
                    <Typography variant='h5' fontWeight="medium">{singleLegal?.weedDeliveryWorks?.pageTitle || "-"}</Typography>
                  </Grid>
                </Grid>
                {sectionCard(singleLegal?.weedDeliveryWorks?.section)}
              </Card>
            }

            {/***************** Same-Day Delivery Timing ****************/}
            {singleLegal?.sameDayDeliveryTiming?.status &&
              <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                  <Typography variant='h5' fontWeight="semibold">Same-Day Delivery Timing</Typography>
                  <StatusText status={singleLegal?.sameDayDeliveryTiming?.status ? "active" : "inactive"} />
                </Stack>
                <Grid container spacing={3} mb={3}>
                  <Grid item xs={12} md={6}>
                    <Typography variant='body2' color={grey[600]} mb={1}>Section Title (H2)</Typography>
                    <Typography variant='h5' fontWeight="medium">{singleLegal?.sameDayDeliveryTiming?.pageTitle || "-"}</Typography>
                  </Grid>
                </Grid>
                {sectionCard(singleLegal?.sameDayDeliveryTiming?.section)}
              </Card>
            }

            {/***************** Same-Day Weed Delivery Areas ****************/}
            {singleLegal?.deliveryAreas?.status &&
              <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                  <Typography variant='h5' fontWeight="semibold">Same-Day Weed Delivery Areas</Typography>
                  <StatusText status={singleLegal?.deliveryAreas?.status ? "active" : "inactive"} />
                </Stack>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Typography variant='body2' color={grey[600]} mb={1}>Page Title (H1)</Typography>
                    <Typography variant='h5' fontWeight="medium">{singleLegal?.deliveryAreas?.pageTitle || "-"}</Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant='body2' color={grey[600]} mb={1}>Description</Typography>
                    <Typography
                      variant="h5"
                      fontWeight="medium"
                      dangerouslySetInnerHTML={{ __html: singleLegal?.deliveryAreas?.description || "-" }}
                    />
                  </Grid>
                </Grid>
              </Card>
            }

            {/***************** Why Choose Hyperwolf for Weed Delivery? ****************/}
            {singleLegal?.hyperwolfForWeedDelivery?.status &&
              <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                  <Typography variant='h5' fontWeight="semibold">Why Choose Hyperwolf for Weed Delivery?</Typography>
                  <StatusText status={singleLegal?.hyperwolfForWeedDelivery?.status ? "active" : "inactive"} />
                </Stack>
                <Grid container spacing={3} mb={3}>
                  <Grid item xs={12} md={6}>
                    <Typography variant='body2' color={grey[600]} mb={1}>Section Title (H2)</Typography>
                    <Typography variant='h5' fontWeight="medium">{singleLegal?.hyperwolfForWeedDelivery?.pageTitle || "-"}</Typography>
                  </Grid>
                </Grid>
                <Stack spacing={3}>
                  {singleLegal?.hyperwolfForWeedDelivery?.section?.map((item, idx) => (
                    <Stack key={item._id || idx} direction="row" spacing={2} alignItems="center">
                      {item.image?.url && (
                        <Box
                          component="img"
                          src={item.image.url}
                          alt={item.image?.alt || item.title}
                          sx={{ width: 24, height: 24, objectFit: 'contain', flexShrink: 0 }}
                        />
                      )}
                      <Typography variant='h6' fontWeight="600">{item.title || "-"}</Typography>
                    </Stack>
                  ))}
                </Stack>
              </Card>
            }

            {/***************** Safe, Licensed & Compliant Cannabis Delivery ****************/}
            {singleLegal?.compliantCannabisDelivery?.status &&
              <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                  <Typography variant='h5' fontWeight="semibold">Safe, Licensed & Compliant Cannabis Delivery</Typography>
                  <StatusText status={singleLegal?.compliantCannabisDelivery?.status ? "active" : "inactive"} />
                </Stack>
                <Grid container spacing={3}>
                  {singleLegal?.compliantCannabisDelivery?.image?.url && (
                    <Grid item xs={12}>
                      <Typography variant='body2' color={grey[600]} mb={1}>Icon</Typography>
                      <Box
                        component="img"
                        src={singleLegal?.compliantCannabisDelivery?.image?.url}
                        alt={singleLegal?.compliantCannabisDelivery?.image?.alt || "icon"}
                        sx={{ width: 64, height: 64, objectFit: 'contain', borderRadius: 1 }}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} md={6}>
                    <Typography variant='body2' color={grey[600]} mb={1}>Section Title (H2)</Typography>
                    <Typography variant='h5' fontWeight="medium">{singleLegal?.compliantCannabisDelivery?.pageTitle || "-"}</Typography>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Typography variant='body2' color={grey[600]} mb={1}>License</Typography>
                    <Typography variant='h5' fontWeight="medium">{singleLegal?.compliantCannabisDelivery?.description || "-"}</Typography>
                  </Grid>
                  {singleLegal?.compliantCannabisDelivery?.content1 && (
                    <Grid item xs={12}>
                      <Typography variant='body2' color={grey[600]} mb={1}>Content 1</Typography>
                      <Typography
                        variant="h5"
                        fontWeight="medium"
                        dangerouslySetInnerHTML={{ __html: singleLegal?.compliantCannabisDelivery?.content1 }}
                      />
                    </Grid>
                  )}
                  {singleLegal?.compliantCannabisDelivery?.content2 && (
                    <Grid item xs={12}>
                      <Typography variant='body2' color={grey[600]} mb={1}>Content 2</Typography>
                      <Typography
                        variant="h5"
                        fontWeight="medium"
                        dangerouslySetInnerHTML={{ __html: singleLegal?.compliantCannabisDelivery?.content2 }}
                      />
                    </Grid>
                  )}
                  {singleLegal?.compliantCannabisDelivery?.section?.length > 0 && (
                    <Grid item xs={12}>
                      <Typography variant='body2' color={grey[600]} mb={2}>Section Items</Typography>
                      {sectionCard(singleLegal?.compliantCannabisDelivery?.section)}
                    </Grid>
                  )}
                </Grid>
              </Card>
            }

            {/***************** Footer Section ****************/}
            <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                <Typography variant='h5' fontWeight="semibold">Footer Section</Typography>
                <StatusText status={singleLegal?.footerSection?.status ? "active" : "inactive"} />
              </Stack>
              {singleLegal?.footerSection?.status &&
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Typography variant='body2' color={grey[600]} mb={1}>Page Title (H1)</Typography>
                        <Typography variant='h5' fontWeight="medium">{singleLegal?.footerSection?.pageTitle || "-"}</Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant='body2' color={grey[600]} mb={1}>Description</Typography>
                        <Typography
                          variant="h5"
                          fontWeight="medium"
                          dangerouslySetInnerHTML={{ __html: singleLegal?.footerSection?.section?.description || "-" }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant='body2' color={grey[600]} mb={1}>Banner Image</Typography>
                        <img
                          style={{ borderRadius: '20px', width: '100%', height: '320px', objectFit: 'cover' }}
                          src={singleLegal?.footerSection?.section?.image?.url || defaultProductImage}
                          alt="No Image Found"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  {singleLegal?.footerSection?.cta?.length > 0 && (
                    <Grid item xs={12}>
                      <Typography variant='body2' color={grey[600]} mb={1}>CTA Buttons</Typography>
                      <Stack direction="row" flexWrap="wrap" gap={2}>
                        {singleLegal?.footerSection?.cta?.map((cta, idx) => (
                          <Box key={idx} sx={{ border: '1px solid #ededed', borderRadius: 1.5, p: 1.5 }}>
                            <Typography variant='body2' fontWeight="600">{cta?.name || "-"}</Typography>
                            <Typography variant='caption' color={grey[600]}>{cta?.link || "-"}</Typography>
                          </Box>
                        ))}
                      </Stack>
                    </Grid>
                  )}
                </Grid>
              }
            </Card>

            {/***************** FAQ ****************/}
            <Card sx={{ p: { xs: 2, md: 3 }, mb: 2, borderRadius: 2.5, boxShadow: 'none' }}>
              <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={3} mb={4}>
                <Typography variant='h5' fontWeight="semibold">FAQs</Typography>
                <StatusText status={singleLegal?.faq?.status ? "active" : "inactive"} />
              </Stack>
              {singleLegal?.faq?.status && <>
                {singleLegal?.faq?.section?.length !== 0 ?
                  <Grid container alignItems="center">
                    {singleLegal?.faq?.section?.map((data, idx) => (
                      <Grid item xs={12} mb={2} key={data._id || idx}>
                        <Typography
                          variant="h5"
                          fontWeight="medium"
                          dangerouslySetInnerHTML={{ __html: data?.question || "-" }}
                        />
                        <Typography
                          variant="body2"
                          color={grey[600]}
                          dangerouslySetInnerHTML={{ __html: data?.answer || "-" }}
                        />
                      </Grid>
                    ))}
                  </Grid>
                  : <NoDataFound />
                }
              </>}
            </Card>

          </Box>
        }
      </>}
    </>
  )
}

export default SameDayDeliveryPageDetail
